import React, { Component } from "react";
import { Box } from "@mui/material";
import Spinner from "react-bootstrap/Spinner";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Cookies from "js-cookie";
import settings from "../../helpers/settings";
import axios from "axios";
import Modal from "@mui/material/Modal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PollIcon from "@mui/icons-material/Poll";
import Accordion from "react-bootstrap/Accordion";
import { FormControl } from "@mui/material";
// import TextField from "@mui/material/TextField";
// import MenuItem from "@mui/material/MenuItem";
// import InputLabel from "@mui/material/InputLabel";
// import Select from "@mui/material/Select";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
// import FormControl from '@mui/material/FormControl';
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import CancelIcon from "@mui/icons-material/Cancel";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from "../AutoComplete";
import { Multiselect } from "multiselect-react-dropdown";
import Container from "react-bootstrap/Container";
import EastIcon from "@mui/icons-material/East";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";


let { KayanURL } = settings;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};
const allInsuraceCompanies = {
  "LICNS-00007": "OQIC Test (LICNS-00007)",
  "NI/23": "LIVA prod (NI/23)",
  "NI/32": "OQIC Prod (NI/32)",
  "FI/9": "New India Prod (FI/9)",
  "LICNS-00001": "AXA Test (LICNS-00001)",
  "LICNS-00014": "Mednet Test (LICNS-00014)",
  "FI/6": "AXA Prod (FI/6)",
  "TPA/004": "Mednet Prod (TPA/004)",
  "LICNS-202315": "New India Test (LICNS-202315)",
  "LICNS-2023156": "Damana Test (LICNS-2023156)",
  "TPA/003": "Vipul Prod (TPA/003)",
  "FI/35": "Damana Prod (FI/35)",
  "LICNS-202329": "Vipul Test (LICNS-202329)",
  "LICNS-202314":"MetLife (LICNS-202314)",
  "TPA/002":"Nextcare(TPA/002)",
  "NI/33": "Arabia Flacon(NI/33)",
  "FI/32":"Sukoon(FI/32)",
  "NI/38": "Muscat (NI/38)",
  "FI/34": "Orient (FI/34)",
  "NI/21": "Dhofar (NI/21)",
  "NI/34": "AlMadina (NI/34)",
  "NI/20": "OmanUnited (NI/20)",
  "LICNS-00013":"Nextcare Test (LICNS-00013)"
};
class AuthorizationHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInfo: {},
      searchFound: false,
      loading: true, serviceOptions: [],
      procedureAutoCompleteValue: false,
      editClaim: false,
      productOrService: {},
      allDiagnosisSelect: [],
      allCareTeamSelect: [],
      vitalSignSelectArray: [],
      vitalSignsArray: [],
      supportingInfo: [],
      vitalSelect: "",
      vitalValue: "",
      offset: 0,
      totalPatients: 0,
      testingFlag: false,
      loadingRowIndex:null

    };
  }
  componentDidMount = async () => {
    this.geTUesrInfo();
    this.getPatientAuthHistory();
    let currentDate = new Date();
    let formattedDate = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1
    ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(
      2,
      "0"
    )}T${String(currentDate.getHours()).padStart(2, "0")}:${String(
      currentDate.getMinutes()
    ).padStart(2, "0")}`;

    let newIdentifier = Date.now();
    this.setState({
      // dateOrdered: formattedDate,
      servicedDate: formattedDate.split("T")[0],
      // start: formattedDate.split("T")[0],
      // end: formattedDate.split("T")[0],

    });

  };

  getPatientAuthHistory = async () => {
    this.setState({ loading: true });

    try {
      let response = await axios.put(
        KayanURL + "/test/patients/claimInfo/getGeneralClaimInfo",
        {
          apiToken: Cookies.get("id"),
        }
      );

      if (response) {
        let { data } = response;
        if (data) {
          console.log(data)
          let { success, claimInfoHistory } = data;
          if (this.state.updateAuth) {
            const updatedSelectedClaim = claimInfoHistory.find(claim => claim.id === this.state.selectedClaim.id);
            if (updatedSelectedClaim) {
              this.setState({ selectedClaim: updatedSelectedClaim })
            }
            this.showAuthorizationInfo(null,updatedSelectedClaim);
          }
          if (success) {
            let sortedAuthHistory = claimInfoHistory.sort((a, b) => b.id - a.id);

            let totalPatients = sortedAuthHistory.length;

            let paginatedAuthHistory = sortedAuthHistory.slice(
              this.state.offset,
              this.state.offset + 20
            );

            this.setState({
              AllPatients: paginatedAuthHistory,
              totalPatients: totalPatients,
              searchFound: false,
              name: "",
              payer_name: "",
              outcome: "",
              searchInfo: {},
            });

            if (paginatedAuthHistory.length === 0) {
              alert("You reached at the end ");
            }
          } else {
            this.setState({
              AllPatients: [],
              searchFound: false,
              name: "",
              payer_name: "",
              outcome: "",
              searchInfo: {},
            });
            alert("There is No Rows Found!");
          }
        }
      }
    } catch (error) {
      console.error("Error fetching patient authorization info:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleNext = () => {
    this.setState(
      prevState => ({ offset: prevState.offset + 20 }),
      () => {
        this.getPatientAuthHistory();
      }
    );
  };

  handlePrevious = () => {
    this.setState(
      prevState => ({ offset: Math.max(prevState.offset - 20, 0) }),
      () => {
        this.getPatientAuthHistory();
      }
    );
  };
  geTUesrInfo = async () => {
    let response = await axios.put(
      KayanURL + "/test/users/getUserInfo",

      {
        apiToken: Cookies.get("id"),
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        let { providerDhamaniID } = data;
        this.setState({ providerDhamaniID });
      }
    }
  };
  showAuthorizationInfo = async (index,element) => {
    // console.log(element, 'selectedddd')
    this.setState({
      showAuthInfo: true,
      showRelated: false,
      loadingRowIndex:index
    })
    let { allDiagnosisSelect, vitalSignSelectArray, allCareTeamSelect } = this.state;
    if (element) {
      let patient = {
        firstName: element.first_name,
        lastName: element.last_name,
        identifier: element.identifier,
        profileId: element.profile_id,
        gender: element.gender,
        birthDate: element.birthdate,
        phone: element.phone,
        identifierType: element.identifier_type,
        country: element.country,
      }
      let response = await axios.put(
        KayanURL + "/test/patients/claimInfo/getClaimInfoByAuthID",
        {
          apiToken: Cookies.get("id"),
          authID: element.id,
          eligibilityID:element.eligibility_serial_id

        }
      );

      if (response) {
        let { data } = response;
        if (data) {
          console.log(data)
          let { success, claimInfoByID } = data;
          if (success) {
            this.setState({loadingRowIndex:null})
            if (claimInfoByID && claimInfoByID.length > 0) {
              let element = claimInfoByID[0];
              element["patient"] = patient;
              console.log(element, 'selectedddd')

              this.setState({
                coverageInfo: element.coverage,
                outcome: element.outcome ? element.outcome : "",
                authorizationRequestIdentifier: element.authorizationrequestidentifier ? element.authorizationrequestidentifier : "",
                authorizationResponseIdentifier:
                  element.authorizationresponseidentifier ? element.authorizationresponseidentifier : "",
                supportingInfo: element.claim ? element.claim.supportingInfo : [],
                allDiagnosis: element.claim ? element.claim.diagnosis : [],
                careTeams: element.claim ? element.claim.careTeam : [],
                procedures: element.claim ? element.claim.items : [],
                items: element.items,
                Total: element.total,
                encounterInfo: element.encounter,
                authErrors: element.errors,
                requestbundleId: element.requestbundleid ? element.requestbundleid : "",
                responsebundleId: element.responsebundleid ? element.responsebundleid : "",
                selectedClaim: element,
                claimInfo: element.claim ? {
                  claimSubType: element.claim.claimSubType,
                  claimType: element.claim.claimType,
                  dateOfCreated: element.claim.created,
                  priority: element.claim.priority,
                  codePrescriber: element.claim.prescriber.code,
                  namePrescriber: element.claim.prescriber.name

                } : {}
              });
              if (
                element.claim.supportingInfo &&
                element.claim.supportingInfo.length > 0 &&
                vitalSignSelectArray.length == 0
              ) {
                let categories = element.claim.supportingInfo;
                // console.log(categories,'cat')
                for (let i = 0; i < categories.length; i++) {
                  vitalSignSelectArray.push({
                    view:
                      categories[i].category +
                      " " +
                      categories[i].valueQuantity +
                      " " +
                      categories[i].valueQuantityCode,
                  });
                  // console.log(vitalSignSelectArray,'vitalllll')
                }
              }
              if (
                element.claim.diagnosis &&
                element.claim.diagnosis.length > 0 &&
                allDiagnosisSelect.length == 0
              ) {
                let allDiagnosisArray = element.claim.diagnosis;
                for (let i = 0; i < allDiagnosisArray.length; i++) {
                  allDiagnosisSelect.push({
                    view: allDiagnosisArray[i].type + " " + allDiagnosisArray[i].code.code,
                  });
                }
              }
              if (
                element.claim.careTeam &&
                element.claim.careTeam.length > 0 &&
                allCareTeamSelect.length == 0
              ) {
                let allCareTeamArray = element.claim.careTeam;
                for (let i = 0; i < allCareTeamArray.length; i++) {
                  allCareTeamSelect.push({
                    view:
                      allCareTeamArray[i].firstName +
                      " " +
                      allCareTeamArray[i].lastName +
                      "-" +
                      allCareTeamArray[i].license,
                  });
                }
              }
            }
          }

        }
      }


    } else {
      this.setState({ showAuthInfo: false });
    }
  };
  handleauthModalClose = () => {
    this.setState({
      showAuthInfo: false,
      vitalSignSelectArray: [],
      addProcedure: false,
      allDiagnosisSelect: [],
      allCareTeamSelect: [],
      editClaim: false,
      // procedures: [],
      // procedure:{}
    });
  };

  HandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };
  handleRadioChange = (e) => {
    console.log(e.target.value, 'radio value')
    let value = e.target.value;
    if (value == "testing") {
      console.log("here")
      this.setState({ testingFlag: true })
    } else {
      this.setState({ testingFlag: false })
    }
  }
  pollRequest = async () => {
    this.setState({
      requestSent: true,
      pollResponse: false,
    });
    let response = await axios.post(KayanURL + "/test/comp/request", {
      apiToken: "test",
      requestType: "3",
      content: {
        providerID: this.state.testingFlag ? "PRV-0031" : this.state.providerDhamaniID,
        providerName: this.state.testingFlag ? "PRV-0031" : this.state.providerDhamaniID,
        include: "priorauth-response",
        testing: this.state.testingFlag
      },
    });
    if (response) {
      this.setState({
        requestSent: false,
        pollResponse: true,
      });
      let { data } = response;
      console.log("data:", data);
      if (data) {
        let { success, response } = data;
        this.setState({ success });
        if (success) {
          this.setState({ pollMsg: "Done" });

          await this.getPatientAuthHistory();
          setTimeout(() => {
            this.setState({ pollMsg: "" });
          }, 1000);
        } else {
          this.setState({ response });
          console.log(response);
        }
      }
    }
  };

  HandleInputSearchRequestTextChange = (e) => {
    let name = e.target.name;
    console.log(name, "name");
    let value = e.target.value;
    console.log(value, "value");
    let patientName,
      patientLastName = "";
    if (name === "name") {
      patientName = value.trim().split(" ");
      if (patientName.length > 1) {
        for (let i = 1; i < patientName.length; i++) {
          patientLastName += patientName[i] + " ";
        }
        this.setState({
          searchInfo: {
            ...this.state.searchInfo,
            first_name: patientName[0],
            last_name: patientLastName.trim(),
          },
          name: value,
        });
      } else {
        this.setState({
          searchInfo: {
            ...this.state.searchInfo,
            first_name: patientName[0],
            last_name: "",
          },
          name: value,
        });
      }
    } else {
      this.setState({
        searchInfo: { ...this.state.searchInfo, [name]: value },
        [name]: value,
      });
    }
  };
  handleSearchRequest = async () => {
    let { searchInfo, AllPatients } = this.state;
    if (Object.keys(searchInfo).length === 0 || searchInfo === undefined) {
      this.setState({ errMsg: "Please select a value to search" });
    }
    for (let key in searchInfo) {
      if (!searchInfo.hasOwnProperty(key) && searchInfo[key] === "") {
        console.log("hooon?")

        this.setState({ errMsg: "Please select a value to search" });
      } else {
        this.setState({
          searchRequestSent: true,
          searchDone: false,
          errMsg: "",
        });
        let selectedPatients = AllPatients.filter((patient) => {
          for (const key in searchInfo) {
            const searchValue = searchInfo[key].toLowerCase();
            const patientValue = patient[key]?.toLowerCase() || "";

            if (!patientValue.includes(searchValue)) {
              return false;
            }
            return true;
          }
        });
        if (selectedPatients && selectedPatients.length > 0) {
          this.setState({ AllPatients: selectedPatients });
          setTimeout(() => {
            this.setState({
              searchRequestSent: false,
              searchDone: true,
              searchFound: true,
            });
          }, 500);
        } else {
          this.setState({ name: "", payer_name: "", disposition: "" });
          this.setState({
            AllPatients: AllPatients,
            errMsg: "No patient with this information...",
          });
          setTimeout(() => {
            this.setState({
              searchRequestSent: false,
              searchDone: true,
              searchFound: true,
            });
          }, 500);
        }
        this.setState({ name: "", payer_name: "", disposition: "" });

        console.log("Selected Patients:", selectedPatients);
      }
    }
  };
  handleCancellation = async (element) => {
    console.log(element, "cancelElem");
    this.setState({
      cancelLoading: true,
      cancelErrors: [],
      cancelError: "",
    });
    let response = await axios.post(KayanURL + "/test/comp/request", {
      apiToken: Cookies.get("id"),
      requestType: "4",
      content: {
        providerId: element.provider_name,
        payerId: element.payer_name,
        requestId: element.authorizationrequestidentifier,
      },
    });

    console.log("cancel Response", response);

    if (response) {
      let { data } = response;
      if (data) {
        let { success, error, result } = data;
        if (success) {
          let cancelStatus;
          let { entry } = result;
          if (entry && entry.length > 0) {
            let { reference } = entry[0]["resource"]["focus"][0];
            let taskResource = entry.filter((element) => {
              return element["fullUrl"] === reference;
            });

            if (taskResource && taskResource.length > 0) {
              console.log(taskResource, "tasksss");
              let errors = [];
              let { output, status, code } = taskResource[0]["resource"];

              if (output && output.length > 0) {
                for (let i = 0; i < output.length; i++) {
                  if (status === "failed") {
                    setTimeout(() => {
                      this.setState({ cancelLoading: false });
                    }, 500);
                    let outputItem = output[i];

                    let { type, valueCodeableConcept } = outputItem;
                    let { coding } = valueCodeableConcept;
                    let { extension } = coding[0];
                    if (type) {
                      let { coding } = type;
                      if (coding && coding.length > 0) {
                        coding = coding[0];

                        let { code } = coding;
                        if (code === "error") {
                          errors.push({
                            code: valueCodeableConcept.coding[0].code,
                            display: valueCodeableConcept.coding[0].display,
                            extension: extension[0].valueString,
                          });
                          this.setState({
                            cancelErrors: errors,
                            cancelModalOpen: true,
                          });
                        }
                      }
                    }
                  }
                }
              } else {
                // console.log(code.coding[0].code);
                if (code.coding && code.coding.length > 0) {
                  cancelStatus = code.coding[0].code;
                }
              }
            }
          }
          if (cancelStatus === "cancel") {
            let updateResponse = await axios.put(
              KayanURL +
              "/test/patients/authorization/updateAuthorizationOutcome",
              {
                apiToken: Cookies.get("id"),
                authId: element.id,
                outcome: "cancellation",
              }
            );

            if (updateResponse) {
              let { data } = updateResponse;
              if (data) {
                console.log(data);
                let { success, error } = data;
                if (success) {
                  setTimeout(() => {
                    this.setState({ cancelLoading: false });
                  }, 1000);
                }
              }
            }
          }
        } else {
          this.setState({ cancelError: error });
        }
      }
    }
    setTimeout(() => {
      this.setState({ cancelError: "" });
    }, 2000);
  };
  handleCloseCancelErrorModal = async () => {
    this.setState({
      cancelModalOpen: false,
      cancelErrors: []
    })
  }
  handleCloseResubmissionErrorModal = async () => {
    this.setState({
      showResubmissionError: false,
      resubmissionErrors: []
    })
  }
  //addProcedures
  getServiceCode = async (type) => {
    let { serviceOptions } = this.state;
    let response = await axios.put(
     /* KayanURL + */"https://om.kayan-healthcare.com/test/data/getAllServices/" + type,
      {
        apiToken: Cookies.get("id"),
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        if (data.success) {
          let { Codes } = data;
          Codes.forEach((e) => {
            serviceOptions.push(e.code + "~" + e.short_description);
          });
          this.setState({ serviceOptions: serviceOptions });
        } else {
          this.setState({ error: data.error });
        }
      }
    }
  };
  handleItemCodeSelect = (value) => {
    let { productOrService } = this.state;
    let split = value.split("~");
    let code = split[0];
    let description = split[1];
    productOrService["code"] = code;
    productOrService["display"] = description;
    this.setState({
      procedureAutoCompleteValue: false,
      productOrService
    });
  };
  HandleProcedureInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ resetProcedure: false, proceduresError: "" });
    let { productOrService } = this.state;
    if (name == "type") {
      this.getServiceCode(value);
      productOrService["list"] = value;
      this.setState({ [name]: value });
      this.setState({ errorItemType: "", procedureAutoCompleteValue: true });
    } else {
      this.setState({
        procedure: { ...this.state.procedure, [name]: value },
        [name]: value,
      });
    }
    if (name === "unitPrice") {
      this.setState({ errorPrice: "" });
    }
    if (name === "factor") {
      this.setState({ errorFactor: "" });
    }
    if (name === "tax") {
      this.setState({ errorTax: "", errorTaxAmount: "" });
    }
    if (name === "patientShare") {
      this.setState({
        errorPatientShare: "",
        errorPayerpatientShare: "",
        errorRequestedpatientShare: "",
      });
    }
  };
  handleRestItemsValue = (e) => {
    e.preventDefault();
    this.setState({
      tax: "",
      code: "",
      description: "",
      patientShare: "",
      unitPrice: "",
      factor: "",
      quantity: "",
      type: "",
      selectedOptions: [],
    });
  };
  handleSave = async (e) => {
    e.preventDefault();
    let { procedures, selectedClaim, editClaim } = this.state;
    if (editClaim) {
      this.setState({
        saveLoading: true,
        addProcedure: false,
      });
      selectedClaim.claim.items = procedures;
      // console.log(selectedClaim.claim.items, 'selected Claim')
      // console.log(selectedClaim,"selectedClaim,,,,,,,,,,,,,,,")
      let Response = await axios.put(
        KayanURL + "/test/patients/authorization/updateAuthorizationInfo",
        {
          authid: selectedClaim.id,
          claim: selectedClaim.claim,
          related: null,
          relatedRelationShip: null,
          apiToken: Cookies.get("id"),
        }
      );
      if (Response) {
        setTimeout(() => {
          this.setState({ saveLoading: false });
        }, 1000);
        let { data } = Response;
        if (data) {
          if (data.success) {
            this.setState({
              success: true,
              editClaim: false,
              // updateclaim: true,
            });
            this.getPatientAuthHistory();
          } else {
            this.setState({ success: false, error: data.error });
          }
        }
      }
    }
  };
  ReSubmissionRequest = async (e) => {
    let { selectedClaim } = this.state;

    console.log(selectedClaim, 'from resubmission')
    e.preventDefault();
    this.setState({
      resubmissionLoading: true,
      updateAuth: false,
      resubmissionErrors: []
    });
    let claimObject = selectedClaim.claim
    claimObject["relatedClaim"] = selectedClaim.authorizationrequestidentifier;
    claimObject["relatedRelationship"] = "aut";
    let authID = Math.floor(Math.random() * 100000).toString();
    selectedClaim.claim["id"] = authID;
    try {
      let response = await axios.post(
        KayanURL + "/test/comp/request",

        {
          apiToken: Cookies.get("id"),
          requestType: "2",
          content: {
            payerName: selectedClaim.payer_name,
            providerName: selectedClaim.provider_name,
            payerId: selectedClaim.payer_id,
            providerId: selectedClaim.provider_name,
            patientId: selectedClaim.patient.profileId,
            patient: selectedClaim.patient,
            encounter: selectedClaim.encounter,
            coverage: selectedClaim.coverage,
            practitioner: selectedClaim.practitioner,
            claim: selectedClaim.claim

          },
        }
      );
      if (response) {
        this.setState({
          requestSent: false,
          response: true,
        });
        let { data } = response;
        // console.log('data:', data);
        if (data) {
          setTimeout(() => {
            this.setState({ resubmissionLoading: false });
          }, 1000);
          let { success, error, response } = data;
          if (response) {
            let { outcome, errors, authorizationRequestIdentifier, authorizationResponseIdentifier, responseBundleID, requestBundleID } = response;
            this.setState({
              resubmissionOutcom: outcome,
              resubmissionRequestIdentifier: authorizationRequestIdentifier,
              resubmissionResponseIdentifier: authorizationResponseIdentifier,
              resubmissionRequestBundleID: requestBundleID,
              resubmissionResponseBundleID: responseBundleID
            })
            if (errors && errors.length > 0) {
              this.setState({ resubmissionErrors: errors })
            }
          }
          if (success) {
            this.updateRelatedInfo(selectedClaim.authorizationrequestidentifier, "aut");
            this.setState({ updateAuth: true });
            await this.getPatientAuthHistory();
            // this.showAuthorizationInfo(selectedClaim);

          } else {
            this.setState({ Autherror: data.response });
            console.log(data.response);
          }
        }
      }
    } catch (error) {
      // console.log("Error in auth:", error);
      this.setState({
        requestSent: false,
        response: true,
        Autherror: "An error occurred while pre authorization. Please try again later."
      });
    }

  };
  updateRelatedInfo = async (related, relatedRelationShip) => {
    let { selectedClaim } = this.state;
    this.setState({
      saveLoading: true,
      addProcedure: false,
    });

    let Response = await axios.put(
      KayanURL + "/test/patients/authorization/updateAuthorizationInfo/",
      {
        authid: selectedClaim.id,
        claim: null,
        related: related,
        relatedRelationShip: relatedRelationShip,
        apiToken: Cookies.get("id"),
      }
    );
    if (Response) {
      setTimeout(() => {
        this.setState({ saveLoading: false });
      }, 1000);
      let { data } = Response;
      if (data) {
        if (data.success) {
          this.setState({
            success: true,
            editClaim: false,
            // updateclaim: true,
          });
          this.getPatientAuthHistory();
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }

  };
  handleAddProcedure = async (e) => {
    e.preventDefault();
    this.setState({
      errorValidForm: "",
    })
    let formIsValid = true;
    if (!this.state.type) {
      this.setState({ errorItemType: "Type is required!" });
      formIsValid = false;
    }
    if (!this.state.unitPrice) {
      this.setState({ errorPrice: "price is required!" });
      formIsValid = false;
    }
    if (!this.state.factor) {
      this.setState({ errorFactor: "factor is required!" });
      formIsValid = false;
    }
    if (!this.state.tax) {
      this.setState({
        errorTax: "tax is required!",
        errorTaxAmount: "Tax or Quantity is required!",
      });
      formIsValid = false;
    }
    if (
      !this.state.unitPrice &&
      !this.state.factor &&
      !this.state.tax &&
      !this.state.quantity
    ) {
      this.setState({ errorNet: "Net is Required!" });
      formIsValid = false;
    } else {
      this.setState({ errorNet: "" });
    }
    if (!this.state.patientShare) {
      this.setState({
        errorPatientShare: "patientShare is required!",
        errorPayerpatientShare: "patientShare is required!",
        errorRequestedpatientShare: "patientShare is required!",
      });
      formIsValid = false;
    } if (!formIsValid) {
      this.setState({ errorValidForm: "Please fill out all required fields." });
      return;
    } else {
      this.setState({
        tax: "",
        patientShare: "",
        unitPrice: "",
        factor: "",
        quantity: "",
        type: "",
        resetProcedure: true,
        // selectedOptions: [],
        procedureAutoCompleteValue: true,
      });

      let { procedures, procedure, productOrService, totalPrice, selectedClaim } = this.state;
      if (procedure) {
        procedure["servicedDate"] = this.state.servicedDate;
        let Net =
          parseFloat(procedure["unitPrice"]) *
          parseFloat(procedure["quantity"]) *
          parseFloat(procedure["factor"]) +
          parseFloat(procedure["tax"]);
        procedure["productOrService"] = productOrService;
        procedure["isPackage"] = this.state.isPackage;
        procedure["net"] = Net;
        // console.log(procedure,"after net")
        totalPrice += procedure["net"];
        this.setState({ totalPrice });
        procedures.push(procedure);
      }
      this.setState({
        procedures,
        // addProceduretotable: true,
        productOrService: {},
        procedure: {},
        proceduresError: "",
        serviceOptions: [],
      });
    }

  };
  handleDeleteProcedure = (index) => {
    let { procedures, totalPrice } = this.state;
    totalPrice -= procedures[index]["net"];
    this.setState({ totalPrice });
    procedures.splice(index, 1);
    if (procedures.length == 0) {
      this.setState({ addProcedure: true });
    }
    this.setState({ procedures });

  };
  handleCheckBoxChange = (e) => {
    if (e.target.name == "package") {
      if (e.target.checked) {
        this.setState({ isPackage: true });
      } else {
        this.setState({ isPackage: false });
      }
    }
  };
  getPriceListInfo = async () => {
    this.setState({ getPriceListLoading: "true" });
    let priceList = await axios.put(
      KayanURL + "/test/patients/priceList/getPriceListInfo",
      {
        standardCode: this.state.productOrService.code,
        nonStandardCode: this.state.nonstandardCode ? this.state.nonstandardCode : "",
        payerId: this.state.selectedClaim.payer_id,
        apiToken: Cookies.get("id"),

      }
    );
    if (priceList) {
      let { data } = priceList;
      if (data) {
        this.setState({ getPriceListLoading: false });
        if (data.success) {
          let { priceList } = data;
          console.log(priceList, "data")

          this.setState({ priceList: priceList });
          if (priceList && priceList.length > 0) {
            this.setState({
              procedure: {
                ...this.state.procedure,
                unitPrice: priceList[0].price,
                factor: priceList[0].factor,
                tax: priceList[0].tax,
                patientShare: priceList[0].patientshare
              },
              unitPrice: priceList[0].price,
              factor: priceList[0].factor,
              tax: priceList[0].tax,
              patientShare: priceList[0].patientshare
            })
          }
        } else {
          this.setState({ error: data.error });
        }
      }
    }
  };
  onSelectCategory = (selectedList) => {
    let { vitalSignSelectArray } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(vitalSignSelectArray.indexOf(item) + 1);
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        informationSequence: Values,
      },
    });
  };
  onRemoveCategory = (selectedList, removedItem) => {
    let { vitalSignSelectArray } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        vitalSignSelectArray.indexOf(item) + 1 !=
        vitalSignSelectArray.indexOf(removedItem) + 1
      ) {
        Values.push(vitalSignSelectArray.indexOf(item) + 1);
      }
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        informationSequence: Values,
      },
    });
  };
  onSelectCareTeams = (selectedList) => {
    let { allCareTeamSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(allCareTeamSelect.indexOf(item) + 1);
    });

    this.setState({
      procedure: {
        ...this.state.procedure,
        careTeamSequence: Values,
      },
    });
  };
  onRemoveCareTeams = (selectedList, removedItem) => {
    let { allCareTeamSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        allCareTeamSelect.indexOf(item) + 1 !=
        allCareTeamSelect.indexOf(removedItem) + 1
      ) {
        Values.push(allCareTeamSelect.indexOf(item) + 1);
      }
    });
  };
  onSelectDiagnosis = (selectedList) => {
    let { allDiagnosisSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(allDiagnosisSelect.indexOf(item) + 1);
    });

    this.setState({
      procedure: {
        ...this.state.procedure,
        diagnosisSequence: Values,
      },
    });
  };
  onRemoveDiagnosis = (selectedList, removedItem) => {
    let { allDiagnosisSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        allDiagnosisSelect.indexOf(item) + 1 !=
        allDiagnosisSelect.indexOf(removedItem) + 1
      ) {
        Values.push(allDiagnosisSelect.indexOf(item) + 1);
      }
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        diagnosisSequence: Values,
      },
    });
  };
  render() {
    const { loading, editClaim, resubmissionErrors } = this.state;
    if (this.state.updateAuth) {
      // console.log(this.state.selectedClaim, 'afterr')
    }
    // console.log(this.state.selectedClaim, 'related')
    let {
      AllPatients,
      careTeams,
      allDiagnosis,
      procedures,
      supportingInfo,
      items,
      Total,
      allPatients,
      allDoctors,
      patientSelected,
      coverageInfo,
      encounterInfo,
      claimInfo,
      authErrors,
    } = this.state;
    // console.log(this.state.pollMsg);
    // console.log(this.state.editClaim, "aaaaaaaaaa");
    let PatientRows = [];
    let careTeamRows = [],
      diagnosisRows = [],
      procedureRows = [],
      allVitalRows = [],
      itemRows = [],
      totalRows = [],
      errorRows = [],
      resubmissionErrorRows = [];
    let CoverageData, encounterData;
    if (careTeams && careTeams.length > 0) {
      careTeamRows = careTeams.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.firstName}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.lastName}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.license}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.role}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.qualification}
            </TableCell>
          </TableRow>
        );
      });
    }
    if (allDiagnosis && allDiagnosis.length > 0) {
      diagnosisRows = allDiagnosis.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {index + 1}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.code.code}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.type}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.code.text}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.onAdmission}{" "}
            </TableCell>
          </TableRow>
        );
      });
    }
    if (procedures && procedures.length > 0) {
      console.log("pppppppp", procedures);
      procedureRows = procedures.map((element, index) => {
        return (
          <TableRow key={index}>
            {/* <TableCell align="center" style={{ fontSize: "small" }}>
              {element.productOrService.code}{""}
            </TableCell> */}
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.productOrService.list}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.productOrService.display}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.unitPrice}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.tax}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.patientShare}{" "}
            </TableCell>
            {element.careTeamSequence && element.careTeamSequence.length > 0 ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.careTeamSequence.toString()}{" "}
              </TableCell>
            ) : (
              <TableCell
                align="center"
                style={{ fontSize: "small" }}
              ></TableCell>
            )}

            {element.diagnosisSequence &&
              element.diagnosisSequence.length > 0 ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.diagnosisSequence.toString()}{" "}
              </TableCell>
            ) : (
              <TableCell
                align="center"
                style={{ fontSize: "small" }}
              ></TableCell>
            )}
            {element.informationSequence &&
              element.informationSequence.length > 0 ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.informationSequence.toString()}{" "}
              </TableCell>
            ) : (
              <TableCell
                align="center"
                style={{ fontSize: "small" }}
              ></TableCell>
            )}
            {editClaim ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                <a
                  onClick={() => {
                    this.handleDeleteProcedure(index);
                  }}
                >
                  <DeleteIcon style={{ cursor: "pointer" }} />
                </a>
              </TableCell>
            ) : null}
          </TableRow>
        );
      });
    }
    if (supportingInfo && supportingInfo.length > 0) {
      allVitalRows = supportingInfo.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {index + 1}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.category}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.valueQuantity} {element.valueQuantityCode}
            </TableCell>
          </TableRow>
        );
      });
    }
    if (items && items.length > 0) {
      let codeIndex = 0;
      itemRows = items.map((element, index) => {
        // console.log(element, "element");
        const procedureCode = procedures[codeIndex].productOrService.code;
        // console.log(procedureCode, "procedureCode");
        codeIndex++;
        const adjudicationRows = element.adjudication.map((element, index) => {
          return (
            <TableRow key={index}>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.category}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.amount}
              </TableCell>
            </TableRow>
          );
        });
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {procedureCode}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.itemSequence}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.outcome}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <TableContainer
                component={Paper}
                style={{
                  margin: "auto",
                  width: "100%",
                }}
              >
                <Table aria-label="simple table">
                  <TableHead style={{ backgroundColor: "#fafafa" }}>
                    <TableRow style={{ textAlign: "center" }}>
                      <TableCell align="center">Category</TableCell>
                      <TableCell align="center">Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{adjudicationRows}</TableBody>
                </Table>
              </TableContainer>
            </TableCell>
          </TableRow>
        );
      });
      console.log(itemRows, "itemRows");
    }
    if (Total && Total.length > 0) {
      totalRows = Total.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.category}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.amount}{" "}
            </TableCell>
          </TableRow>
        );
      });
    }
    if (AllPatients && AllPatients.length > 0) {
      const convertToOmanTime = (utcFormattedDate) => {
        const utcDate = new Date(utcFormattedDate);
        utcDate.setUTCHours(utcDate.getUTCHours() + 4);
        const omanFormattedDate = `${utcDate.getFullYear()}-${String(
          utcDate.getMonth() + 1
        ).padStart(2, "0")}-${String(utcDate.getUTCDate()).padStart(2, "0")}
            T${String(utcDate.getUTCHours()).padStart(2, "0")}:${String(
          utcDate.getUTCMinutes()
        ).padStart(2, "0")}`;
        return omanFormattedDate;
      };
      const sortedByID = AllPatients.map((patient, index) => ({
        index,
        patient,
      }))
        .sort((a, b) =>
          new Date(b.patient.formatteddate)
            .toISOString()
            .localeCompare(new Date(a.patient.formatteddate).toISOString())
        )
        .map((pair) => pair.patient);
      // console.log(sortedByID, "ssssssssssssss");
      PatientRows = sortedByID.map((element, index) => {
        const omanTime = new Date(element.formatteddate).toLocaleString(
          "en-US",
          { timeZone: "Asia/Muscat" }
        );
          //  console.log(element.payer_name,'hhh')
        let adjudicationOutcome = "";
        if (element.outcome === "error" || element.outcome === "queued") {
          adjudicationOutcome = "";
        } else {
          if (element.items && element.items.length > 0) {
            const outcomes = element.items.map((e) => e.outcome);
            if (outcomes.every((outcome) => outcome === "rejected")) {
              adjudicationOutcome = "rejected";
            } else if (outcomes.every((outcome) => outcome === "approved")) {
              adjudicationOutcome = "approved";
            } else if (
              outcomes.includes("partial") &&
              (outcomes.includes("approved") || outcomes.includes("rejected"))
            ) {
              adjudicationOutcome = "partial approved";
            } else if (
              (outcomes.includes("approved") && outcomes.includes("rejected")) ||
              outcomes.includes("partial")
            ) {
              adjudicationOutcome = "partial approved";
            }
          }
        }
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {element.first_name} {element.last_name}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {element.profile_id}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {element.practitioner.name}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {allInsuraceCompanies[element.payer_name]}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {element.provider_name}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {element.outcome}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {/* {element.adjudicationoutcome} */}
              {adjudicationOutcome}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {omanTime}{" "}
            </TableCell>
            {/* <TableCell align="center" style={{ fontSize: "10px" }}>
              {element.responsebundleid}
            </TableCell> */}
            {/* <TableCell align="center" style={{ fontSize: "10px" }}>
              <a
                onClick={(e) => {
                  this.pollRequest(element);
                }}
                style={{ cursor: "pointer" }}
              >
                <PollIcon style={{ color: "grey", fontSize: "15px" }} />
              </a>

            </TableCell> */}
            <TableCell align="center" style={{ fontSize: "13px" }}>
              <a
                style={{ cursor: "pointer" }}
                onClick={() => {
                  this.handleCancellation(element);
                }}
              >
                <CancelIcon style={{ color: "grey", fontSize: "15px" }} />
              </a>
            </TableCell>

            <TableCell align="center" style={{ fontSize: "13px" }}>
              <a
                onClick={(e) => {
                  this.showAuthorizationInfo(index,element);
                }}
                style={{ cursor: "pointer" }}
              >
                 {this.state.loadingRowIndex === index ? (
                  <>
                    <Spinner style={{fontSize:"10px",color: "grey"}} animation="border" variant="success" />
                  </>
                ) : (
                  <VisibilityIcon style={{ color: "grey", fontSize: "15px" }} />
                )}
              </a>
            </TableCell>
          </TableRow>
        );
      });
    }
    if (coverageInfo) {
      CoverageData = (
        <>
          <TableRow key={coverageInfo.id}>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.bundleId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.class[0].type}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.class[0].value}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.coverageEligibilityRequestId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.fullUrl}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.id}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.memberid}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.messageId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.patientId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.relationship}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.status}{" "}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.period.start}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.period.end}{" "}
            </TableCell>
          </TableRow>
        </>
      );
    }
    if (encounterInfo) {
      encounterData = (
        <>
          <TableRow key={encounterInfo.id}>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {encounterInfo.id}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {encounterInfo.class.code}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {encounterInfo.class.display}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {encounterInfo.identifier}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {encounterInfo.providerId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {encounterInfo.status}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {encounterInfo.type}{" "}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "10px" }}>
              {encounterInfo.period.start}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {encounterInfo.period.end}{" "}
            </TableCell>
          </TableRow>
        </>
      );
    }
    if (authErrors && authErrors.length > 0) {
      errorRows = authErrors.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.code}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.display}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.extension}{" "}
            </TableCell>
          </TableRow>
        );
      });
    }
    if (resubmissionErrors && resubmissionErrors.length > 0) {
      resubmissionErrorRows = resubmissionErrors.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.code}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.display}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.extension}{" "}
            </TableCell>
          </TableRow>
        );
      });
    }
    return (
      <>
        <Box height={60} />
        <>
          <div
            style={{
              textAlign: "left",
              boxShadow: "1px solid grey",
              padding: "15px",
              boxShadow:
                "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
              borderRadius: "10px",
            }}
          >
            <div>
              <div style={{ width: "90%", margin: "auto", padding: "20px" }}>
                <Accordion
                  defaultActiveKey="0"
                  style={{
                    margin: "auto",
                    paddingBottom: "0px",
                    width: "80%",
                  }}
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <span style={{ color: "grey" }}>Search Claim</span>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Row>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: "13px" }}>
                              Patient Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="name"
                              value={this.state.name ? this.state.name : ""}
                              required
                              onChange={this.HandleInputSearchRequestTextChange}
                              placeholder="Enter Patient Name"
                            />
                          </Form.Group>

                          <div style={{ width: "100%" }}>
                            <Button
                              variant="contained"
                              style={{
                                width: "50%",
                                backgroundColor: "rgb(97 110 120",
                                marginRight: "10px",
                                color: "white",
                              }}
                              onClick={(e) => this.handleSearchRequest(e)}
                            >
                              search
                            </Button>
                          </div>
                        </Col>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: "13px" }}>
                              Payer name
                            </Form.Label>
                            <Form.Select
                              onChange={this.HandleInputSearchRequestTextChange}
                              required
                              value={
                                this.state.payer_name
                                  ? this.state.payer_name
                                  : ""
                              }
                              name="payer_name"
                            >
                              <option value="0">select...</option>
                              <option value="LICNS-202315">
                                New India Test (LICNS-202315)
                              </option>
                              <option value="LICNS-00007">
                                OQIC Test (LICNS-00007)
                              </option>
                              <option value="LICNS-00001">
                                AXA Test (LICNS-00001)
                              </option>
                              <option value="LICNS-00014">
                                Mednet Test (LICNS-00014)
                              </option>
                              <option value="LICNS-202329">
                                Vipul Test (LICNS-202329)
                              </option>
                              <option value="LICNS-2023156">
                                Damana Test (LICNS-2023156)
                              </option>

                              <option value="NI/23">LIVA prod (NI/23) </option>
                              <option value="FI/9">
                                New India Prod (FI/9)
                              </option>
                              <option value="NI/32">OQIC Prod (NI/32)</option>
                              <option value="FI/6">AXA Prod (FI/6)</option>
                              <option value="TPA/004">
                                Mednet Prod (TPA/004)
                              </option>
                              <option value="TPA/003">
                                Vipul Prod (TPA/003)
                              </option>
                              <option value="FI/35">Damana Prod (FI/35)</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: "13px" }}>
                              Status
                            </Form.Label>
                            <Form.Select
                              onChange={this.HandleInputSearchRequestTextChange}
                              required
                              value={
                                this.state.outcome ? this.state.outcome : ""
                              }
                              name="outcome"
                            >
                              <option value="0">select...</option>
                              <option value="complete">Complete</option>
                              <option value="queued">Queued</option>
                              <option value="error">Error</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        {this.state.errMsg ? (
                          <>
                            <Typography
                              style={{ textAlign: "center", color: "red" }}
                            >
                              {this.state.errMsg}
                            </Typography>
                          </>
                        ) : null}
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                {this.state.searchRequestSent && !this.state.searchDone ? (
                  <div style={{ textAlign: "center", marginTop: "10px" }}>
                    <Spinner animation="border" variant="success" />
                  </div>
                ) : this.state.searchDone && this.state.error ? (
                  <h5 style={{ color: "red", textAlign: "center" }}>
                    {this.state.error}
                  </h5>
                ) : null}
              </div>
              <div style={{ width: "100%", margin: "auto", padding: "20px" }}>
                {this.state.requestSent && !this.state.pollRequest ? (
                  <div style={{ textAlign: "center", marginTop: "10px" }}>
                    <Spinner animation="border" variant="success" />
                  </div>
                ) : this.state.success ? (
                  <h5 style={{ color: "green", textAlign: "center" }}>
                    {this.state.pollMsg}
                  </h5>
                ) : this.state.pollRequest && this.state.response ? (
                  <h5 style={{ color: "red", textAlign: "center" }}>
                    {this.state.response}
                  </h5>
                ) : null}
                <div>
                  <hr />
                  {this.state.cancelLoading ? (
                    <div style={{ textAlign: "center", marginTop: "30px" }}>
                      <Spinner animation="border" variant="success" />
                    </div>
                  ) : null}
                  {loading ? (
                    <div style={{ textAlign: "center", marginTop: "30px" }}>
                      <Spinner animation="border" variant="success" />
                    </div>
                  ) : (
                    <>
                      {AllPatients && AllPatients.length > 0 ? (
                        <>
                          {/* <hr /> */}
                          <div style={{ textAlign: "right" }}>
                            <FormControl>
                              <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                // value={value}
                                onChange={this.handleRadioChange}
                              >
                                <FormControlLabel value="testing" control={<Radio />} label="Testing" />
                                <FormControlLabel value="production" control={<Radio />} label="Production" />
                              </RadioGroup>
                            </FormControl>
                          </div>
                          <div style={{ position: "fixed" }}>
                            <Button
                              onClick={() => this.pollRequest()}
                              style={{
                                position: "absolute",
                                bottom: "20px",
                                left: "50%",
                                cursor: "pointer",
                                marginTop: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                padding: "8px 16px",
                                backgroundColor: "#fff",
                                color: "#333",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                              }}
                              variant="contained"
                            >
                              <span style={{ marginRight: "5px" }}>
                                pollRequest
                              </span>
                              <PollIcon
                                style={{ color: "grey", fontSize: "15px" }}
                              />
                            </Button>
                          </div>

                          <TableContainer
                            component={Paper}
                            style={{
                              margin: "auto",
                              marginTop: "30px",
                              width: "100%",
                            }}
                          >
                            <Table aria-label="simple table">
                              <TableHead style={{ backgroundColor: "#fafafa" }}>
                                <TableRow style={{ textAlign: "center" }}>
                                  {/* <TableCell align="center">ID</TableCell> */}
                                  <TableCell align="center">Name</TableCell>
                                  <TableCell align="center">
                                    Patient ID
                                  </TableCell>
                                  <TableCell align="center">
                                    Doctor Name
                                  </TableCell>
                                  <TableCell align="center">
                                    Payer Name
                                  </TableCell>
                                  <TableCell align="center">
                                    Provider Name
                                  </TableCell>
                                  <TableCell align="center">Status</TableCell>
                                  <TableCell align="center">
                                    Adjudication Outcome
                                  </TableCell>
                                  {/* <TableCell align="center">Request Bundle ID</TableCell>
                              <TableCell align="center">Response Bundle ID</TableCell> */}
                                  <TableCell align="center">Time</TableCell>
                                  <TableCell align="center">
                                    Cancellation
                                  </TableCell>
                                  <TableCell align="center">
                                    Show More
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>{PatientRows}</TableBody>
                            </Table>
                          </TableContainer>
                          <Button variant="contained"
                            style={{
                              width: "10%",
                              backgroundColor: "rgb(97 110 120",
                              marginTop: "10px",
                              color: "white",
                              marginRight: "10px",
                            }}
                            onClick={this.handlePrevious}
                            disabled={this.state.loading || this.state.offset === 0}
                          >
                            Previous
                          </Button>
                          <Button variant="contained"
                            style={{
                              width: "10%",
                              backgroundColor: "rgb(97 110 120",
                              marginTop: "10px",
                              color: "white",
                            }}
                            onClick={this.handleNext}
                            disabled={this.state.loading || this.state.offset + 20 >= this.state.totalPatients}
                          >
                            Next
                          </Button>
                        </>
                      ) : (
                        <h5 style={{ color: "red", textAlign: "center" }}>
                          There is No Rows Found!
                        </h5>
                      )}
                    </>
                  )}
                  {this.state.searchFound ? (
                    <>
                      <div style={{ width: "100%" }}>
                        <Button
                          variant="contained"
                          style={{
                            width: "10%",
                            backgroundColor: "rgb(97 110 120",
                            marginTop: "10px",
                            color: "white",
                          }}
                          onClick={(e) => this.getPatientAuthHistory(e)}
                        >
                          clear filter
                        </Button>
                      </div>
                    </>
                  ) : null}
                  {this.state.showAuthInfo ? (
                    <Modal
                      open={this.state.showAuthInfo}
                      onClose={this.handleauthModalClose}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      <Box
                        sx={style}
                        style={{
                          width: "85%",
                          height: "85%",
                          overflowY: "scroll",
                        }}
                      >
                        <div>
                          <Row>
                            <div style={{ width: "70%" }}>
                              <Button
                                variant="contained"
                                style={{
                                  backgroundColor: "rgb(97 110 120)",
                                  border: "1px ridge gray",
                                  width: "25%",
                                  color: "white",
                                  fontSize: "smaller",
                                  margin: "auto",
                                  marginRight: "3px",
                                  transition: "background-color 0.4s, color 0.4s",
                                  fontSize: "11px",
                                }}
                                onClick={(e) => {
                                  this.setState({
                                    editClaim: true,
                                  },
                                    // () => this.handleSave(e)
                                  );
                                  this.handleSave(e);
                                }}
                              >
                                {editClaim
                                  ? this.state.saveLoading
                                    ? "Loading..."
                                    : "save"
                                  : "Edit"}
                              </Button>
                              <Button
                                variant="contained"
                                style={{
                                  backgroundColor: "rgb(97 110 120)",
                                  border: "1px ridge gray",
                                  width: "25%",
                                  color: "white",
                                  fontSize: "smaller",
                                  margin: "auto",
                                  marginRight: "3px",
                                  transition: "background-color 0.4s, color 0.4s",
                                  fontSize: "11px",
                                }}
                                onClick={(e) =>
                                  this.ReSubmissionRequest(e)
                                }
                              >
                                {this.state.resubmissionLoading
                                  ? "Loading..."
                                  : " Resubmission"}

                              </Button>
                              {this.state.selectedClaim && this.state.selectedClaim.relatedclaim ? (
                                <Button
                                  variant="contained"
                                  style={{
                                    backgroundColor: "rgb(97 110 120)",
                                    border: "1px ridge gray",
                                    width: "25%",
                                    color: "white",
                                    fontSize: "smaller",
                                    margin: "auto",
                                    transition: "background-color 0.4s, color 0.4s",
                                    fontSize: "11px",
                                  }}
                                  onClick={(e) =>
                                    this.setState({
                                      showRelated: true
                                    })
                                  }
                                >
                                  Show Related Info

                                </Button>
                              ) : (
                                <Button
                                  variant="contained"
                                  disabled
                                  style={{
                                    backgroundColor: "rgb(97 110 120)",
                                    border: "1px ridge gray",
                                    width: "25%",
                                    color: "white",
                                    fontSize: "smaller",
                                    margin: "auto",
                                    transition: "background-color 0.4s, color 0.4s",
                                    fontSize: "11px",
                                  }}
                                >
                                  Show Related Info

                                </Button>
                              )}
                            </div>
                          </Row>
                          {this.state.showRelated ? (
                            <>
                              {this.state.resubmissionRequestBundleID ? (
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "left" }}
                                >
                                  Request BundleID : {this.state.resubmissionRequestBundleID}
                                </Typography>
                              ) : null}
                              {this.state.resubmissionResponseBundleID ? (
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "left" }}
                                >
                                  Response BundleID : {this.state.resubmissionResponseBundleID}
                                </Typography>
                              ) : null}
                              {this.state.resubmissionOutcom ? (
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "left" }}
                                >
                                  Outcome : {this.state.resubmissionOutcom === "error" ? (
                                    <>
                                      <a style={{ color: "red" }}
                                        onClick={(e) =>
                                          this.setState({
                                            showResubmissionError: true
                                          })
                                        }>
                                        {this.state.resubmissionOutcom}
                                      </a>
                                    </>
                                  ) : this.state.resubmissionOutcom}
                                </Typography>
                              ) : null}
                              {this.state.resubmissionRequestIdentifier ? (
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "left" }}
                                >
                                  Request Identifier : {this.state.resubmissionRequestIdentifier}
                                </Typography>
                              ) : null}
                              {this.state.resubmissionResponseIdentifier ? (
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "left" }}
                                >
                                  ResponseIdentifier : {this.state.resubmissionResponseIdentifier}
                                </Typography>
                              ) : null}
                              <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                                style={{ textAlign: "left" }}
                              >
                                Related Claim : {this.state.selectedClaim.relatedclaim}
                              </Typography>
                              <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                                style={{ textAlign: "left" }}
                              >
                                Related Claim Relationship : {this.state.selectedClaim.relatedrelationship}
                              </Typography>

                            </>

                          ) : null}
                          <Row>
                            {CoverageData ? (
                              <>
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "center" }}
                                >
                                  Coverage Info
                                </Typography>
                                <TableContainer
                                  component={Paper}
                                  style={{
                                    margin: "auto",
                                    marginTop: "30px",
                                    width: "100%",
                                  }}
                                >
                                  <Table aria-label="simple table">
                                    <TableHead
                                      style={{ backgroundColor: "#fafafa" }}
                                    >
                                      <TableRow style={{ textAlign: "center" }}>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          bundle ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Class Type
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Class Value
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          {" "}
                                          Coverage Eligibility Request ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Full URL
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Coverage ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Member ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Message ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Patient ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Relationship
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Status
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Start Data
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          End Data
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>{CoverageData}</TableBody>
                                  </Table>
                                </TableContainer>
                              </>
                            ) : null}
                            {encounterData ? (
                              <>
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "center" }}
                                >
                                  Encounter Info
                                </Typography>
                                <TableContainer
                                  component={Paper}
                                  style={{
                                    margin: "auto",
                                    marginTop: "30px",
                                    width: "100%",
                                  }}
                                >
                                  <Table aria-label="simple table">
                                    <TableHead
                                      style={{ backgroundColor: "#fafafa" }}
                                    >
                                      <TableRow style={{ textAlign: "center" }}>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Class Code
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Class Display
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Identifier
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Provider ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Status
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Type
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Start Data
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          End Data
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>{encounterData}</TableBody>
                                  </Table>
                                </TableContainer>
                              </>
                            ) : null}
                          </Row>
                          <Row>
                            {allDiagnosis && allDiagnosis.length > 0 ? (
                              <>
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "center" }}
                                >
                                  Diagnosis Information
                                </Typography>
                                <TableContainer
                                  component={Paper}
                                  style={{
                                    margin: "10px auto 10px",
                                  }}
                                >
                                  <Table aria-label="simple table">
                                    <TableHead
                                      style={{ backgroundColor: "#fafafa" }}
                                    >
                                      <TableRow style={{ textAlign: "center" }}>
                                        <TableCell align="center">ID</TableCell>
                                        <TableCell align="center">
                                          Code
                                        </TableCell>
                                        <TableCell align="center">
                                          Type
                                        </TableCell>
                                        <TableCell align="center">
                                          Description
                                        </TableCell>
                                        <TableCell align="center">
                                          On Admission
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>{diagnosisRows}</TableBody>
                                  </Table>
                                </TableContainer>
                              </>
                            ) : null}

                            <>
                              <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                                style={{ textAlign: "center" }}
                              >
                                Claim Information
                              </Typography>
                              <TableContainer
                                component={Paper}
                                style={{
                                  margin: "10px auto 10px",
                                }}
                              >
                                <Table aria-label="simple table">
                                  <TableHead
                                    style={{ backgroundColor: "#fafafa" }}
                                  >
                                    <TableRow style={{ textAlign: "center" }}>
                                      {/* <TableCell align="center">ID</TableCell> */}
                                      <TableCell align="center">
                                        Claim Sub Type
                                      </TableCell>
                                      <TableCell align="center">
                                        Claim Type
                                      </TableCell>
                                      <TableCell align="center">
                                        Date of created
                                      </TableCell>
                                      <TableCell align="center">
                                        priority
                                      </TableCell>
                                      <TableCell align="center">prescriber
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>

                                    <TableRow style={{ textAlign: "center" }}>
                                      <TableCell align="center">{this.state.claimInfo ? this.state.claimInfo.claimSubType : ""}</TableCell>
                                      <TableCell align="center">{this.state.claimInfo ? this.state.claimInfo.claimType : ""}</TableCell>
                                      <TableCell align="center">{this.state.claimInfo ? this.state.claimInfo.dateOfCreated : ""}</TableCell>
                                      <TableCell align="center">{this.state.claimInfo ? this.state.claimInfo.priority : ""}</TableCell>
                                      <TableCell align="center">{this.state.claimInfo ? this.state.claimInfo.codePrescriber : ""}
                                        {this.state.claimInfo ? this.state.claimInfo.namePrescriber : ""}</TableCell>


                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </>
                            {/* ) : null} */}

                            {this.state.supportingInfo &&
                              this.state.supportingInfo.length > 0 ? (
                              <Col>
                                <>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    style={{ textAlign: "center" }}
                                  >
                                    Supporting Information
                                  </Typography>
                                  <TableContainer
                                    component={Paper}
                                    style={{
                                      margin: "10px auto 10px",
                                    }}
                                  >
                                    <Table aria-label="simple table">
                                      <TableHead
                                        style={{ backgroundColor: "#fafafa" }}
                                      >
                                        <TableRow
                                          style={{ textAlign: "center" }}
                                        >
                                          <TableCell align="center">
                                            ID
                                          </TableCell>
                                          <TableCell align="center">
                                            Category
                                          </TableCell>
                                          <TableCell align="center">
                                            Value
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>

                                      <TableBody>{allVitalRows}</TableBody>
                                    </Table>
                                  </TableContainer>
                                </>
                              </Col>
                            ) : null}
                            {careTeams && careTeams.length > 0 ? (
                              <>
                                <Col>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    style={{ textAlign: "center" }}
                                  >
                                    Care Teams Information
                                  </Typography>
                                  <TableContainer
                                    component={Paper}
                                    style={{
                                      margin: "10px auto 10px",
                                    }}
                                  >
                                    <Table aria-label="simple table">
                                      <TableHead
                                        style={{ backgroundColor: "#fafafa" }}
                                      >
                                        <TableRow
                                          style={{ textAlign: "center" }}
                                        >
                                          <TableCell align="center">
                                            First Name
                                          </TableCell>
                                          <TableCell align="center">
                                            Last Name
                                          </TableCell>
                                          <TableCell align="center">
                                            License
                                          </TableCell>
                                          <TableCell align="center">
                                            Role
                                          </TableCell>
                                          <TableCell align="center">
                                            Speciality
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>{careTeamRows}</TableBody>
                                    </Table>
                                  </TableContainer>
                                </Col>
                              </>
                            ) : null}
                          </Row>
                          <Row>
                            {(procedures && procedures.length > 0) || this.state.addProcedure ? (
                              <>
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "center" }}
                                >
                                  Procedures
                                </Typography>
                                <TableContainer
                                  component={Paper}
                                  style={{
                                    margin: "10px auto 10px",
                                    width: "100%",
                                  }}
                                >
                                  <Table aria-label="simple table">
                                    <TableHead
                                      style={{ backgroundColor: "#fafafa" }}
                                    >
                                      <TableRow style={{ textAlign: "center" }}>
                                        {/* <TableCell align="center">Code</TableCell> */}
                                        <TableCell align="center">
                                          Type
                                        </TableCell>
                                        <TableCell align="center">
                                          Description
                                        </TableCell>
                                        <TableCell align="center">
                                          Price
                                        </TableCell>
                                        <TableCell align="center">
                                          Tax
                                        </TableCell>
                                        <TableCell align="center">
                                          Patient Share
                                        </TableCell>
                                        <TableCell align="center">
                                          Related Care Teams
                                        </TableCell>
                                        <TableCell align="center">
                                          Related Diagnosis
                                        </TableCell>
                                        <TableCell align="center">
                                          Related Supporting Info
                                        </TableCell>
                                        {editClaim ? (
                                          <TableCell align="center">
                                            Action
                                          </TableCell>
                                        ) : null}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>{procedureRows}</TableBody>
                                    {this.state.addProcedure ? (
                                      <TableRow>
                                        <TableCell
                                          colSpan={
                                            9
                                          }
                                        >
                                          <Accordion
                                            defaultActiveKey="0"
                                            style={{
                                              width: "100%",
                                              margin: "20px 0",
                                            }}
                                          >
                                            <Accordion.Item eventKey="0">
                                              <Accordion.Header>
                                                <span>Items Information</span>
                                              </Accordion.Header>
                                              <Accordion.Body>
                                                <FormControl style={{ width: "100%" }}>
                                                  <Container>
                                                    <Row>
                                                      <Col>
                                                        <Form.Group className="mb-3">
                                                          <Form.Label style={{ fontSize: "13px" }}>
                                                            Type *
                                                          </Form.Label>
                                                          <Form.Select
                                                            onChange={this.HandleProcedureInputTextChange}
                                                            // required
                                                            name="type"
                                                            value={this.state.type}
                                                          >
                                                            <option value="0">select Type</option>
                                                            <option value="CDT">CDT</option>
                                                            <option value="CPT">CPT</option>
                                                            <option value="MEDICATION">Medication</option>
                                                            <option value="OSL">OSL</option>
                                                          </Form.Select>
                                                          {this.state.errorItemType ? (
                                                            <span
                                                              style={{
                                                                color: "red",
                                                                fontSize: "10px",
                                                                marginBottom: "0",
                                                              }}
                                                            >
                                                              {this.state.errorItemType}
                                                            </span>
                                                          ) : null}
                                                        </Form.Group>
                                                      </Col>
                                                      <Col>
                                                        <FormControl sx={{ mb: 3, width: "100%" }}>
                                                          <Form.Label style={{ fontSize: "13px" }}>
                                                            Code
                                                          </Form.Label>
                                                          <Autocomplete
                                                            sx={{
                                                              ".css-1x51dt5-MuiInputBase-input-MuiInput-input":
                                                              {
                                                                marginTop: "2px",
                                                                border: "1px solid #80808080",
                                                                borderRadius: "5px",
                                                                paddingTop: "4px",
                                                              },
                                                            }}
                                                            suggestions={this.state.serviceOptions}
                                                            onChangeSetCode={this.handleItemCodeSelect}
                                                            flag={this.state.procedureAutoCompleteValue}
                                                          />
                                                        </FormControl>
                                                      </Col>
                                                      <Col>
                                                        <Form.Group className="mb-3">
                                                          <Form.Label style={{ fontSize: "13px" }}>
                                                            Requested QTY
                                                          </Form.Label>
                                                          <Form.Control
                                                            type="text"
                                                            name="quantity"
                                                            // required
                                                            value={this.state.quantity}
                                                            onChange={this.HandleProcedureInputTextChange}
                                                            placeholder="Enter Qty"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                    </Row>
                                                    <hr />
                                                    <span>Calculations</span>
                                                    <Row>
                                                      <div style={{ width: "43%" }}>
                                                        <Col>
                                                          <Row>
                                                            <Col>
                                                              <Form.Group className="mb-3">
                                                                <Form.Label style={{ fontSize: "10px" }}>
                                                                  Unit Price *
                                                                </Form.Label>
                                                                <Form.Control
                                                                  type="text"
                                                                  name="unitPrice"
                                                                  required
                                                                  value={this.state.unitPrice}
                                                                  onChange={
                                                                    this.HandleProcedureInputTextChange
                                                                  }
                                                                />
                                                              </Form.Group>
                                                              {this.state.errorPrice ? (
                                                                <span
                                                                  style={{
                                                                    color: "red",
                                                                    fontSize: "10px",
                                                                    marginBottom: "0",
                                                                  }}
                                                                >
                                                                  {this.state.errorPrice}
                                                                </span>
                                                              ) : null}
                                                            </Col>
                                                            <Col>
                                                              <Form.Group className="mb-3">
                                                                <Form.Label style={{ fontSize: "10px" }}>
                                                                  Factor *
                                                                </Form.Label>
                                                                <Form.Control
                                                                  type="text"
                                                                  name="factor"
                                                                  required
                                                                  value={this.state.factor}
                                                                  onChange={
                                                                    this.HandleProcedureInputTextChange
                                                                  }
                                                                />
                                                              </Form.Group>
                                                              {this.state.errorFactor ? (
                                                                <span
                                                                  style={{
                                                                    color: "red",
                                                                    fontSize: "10px",
                                                                    marginBottom: "0",
                                                                  }}
                                                                >
                                                                  {this.state.errorFactor}
                                                                </span>
                                                              ) : null}
                                                            </Col>
                                                            <Col>
                                                              <Form.Group className="mb-3">
                                                                <Form.Label style={{ fontSize: "10px" }}>
                                                                  Tax *
                                                                </Form.Label>
                                                                <Form.Control
                                                                  type="text"
                                                                  name="tax"
                                                                  required
                                                                  value={this.state.tax}
                                                                  onChange={
                                                                    this.HandleProcedureInputTextChange
                                                                  }
                                                                />
                                                              </Form.Group>
                                                              {this.state.errorTax ? (
                                                                <span
                                                                  style={{
                                                                    color: "red",
                                                                    fontSize: "10px",
                                                                    marginBottom: "0",
                                                                  }}
                                                                >
                                                                  {this.state.errorTax}
                                                                </span>
                                                              ) : null}
                                                            </Col>
                                                            <Col>
                                                              <Form.Group className="mb-3">
                                                                <Form.Label style={{ fontSize: "10px" }}>
                                                                  Patient Share *
                                                                </Form.Label>
                                                                <Form.Control
                                                                  type="text"
                                                                  name="patientShare"
                                                                  required
                                                                  value={this.state.patientShare}
                                                                  onChange={
                                                                    this.HandleProcedureInputTextChange
                                                                  }
                                                                />
                                                              </Form.Group>
                                                              {this.state.errorPatientShare ? (
                                                                <span
                                                                  style={{
                                                                    color: "red",
                                                                    fontSize: "10px",
                                                                    marginBottom: "0",
                                                                  }}
                                                                >
                                                                  {this.state.errorPatientShare}
                                                                </span>
                                                              ) : null}
                                                            </Col>
                                                          </Row>
                                                        </Col>
                                                      </div>
                                                      <div
                                                        style={{
                                                          width: "14%",
                                                          margin: "auto",
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        <Col>
                                                          <EastIcon />
                                                        </Col>
                                                      </div>
                                                      <div style={{ width: "43%" }}>
                                                        <Col>
                                                          <Row>
                                                            <Col>
                                                              <Form.Group className="mb-3">
                                                                <Form.Label style={{ fontSize: "10px" }}>
                                                                  Tax Amount *
                                                                </Form.Label>
                                                                <Form.Control
                                                                  type="number"
                                                                  name="TaxAmount"
                                                                  // required
                                                                  readOnly
                                                                  value={
                                                                    this.state.quantity && this.state.tax
                                                                      ? this.state.quantity * this.state.tax
                                                                      : ""
                                                                  }
                                                                // onChange={this.HandleProcedureInputTextChange}
                                                                />
                                                              </Form.Group>
                                                              {this.state.errorTaxAmount ? (
                                                                <span
                                                                  style={{
                                                                    color: "red",
                                                                    fontSize: "10px",
                                                                    marginBottom: "0",
                                                                  }}
                                                                >
                                                                  {this.state.errorTaxAmount}
                                                                </span>
                                                              ) : null}
                                                            </Col>
                                                            <Col>
                                                              <Form.Group className="mb-3">
                                                                <Form.Label style={{ fontSize: "10px" }}>
                                                                  Net *
                                                                </Form.Label>
                                                                <Form.Control
                                                                  type="number"
                                                                  name="net"
                                                                  // required
                                                                  readOnly
                                                                  value={
                                                                    this.state.quantity &&
                                                                      this.state.unitPrice &&
                                                                      this.state.tax
                                                                      ? this.state.quantity *
                                                                      this.state.unitPrice +
                                                                      this.state.quantity * this.state.tax
                                                                      : ""
                                                                  }
                                                                  onChange={
                                                                    this.HandleProcedureInputTextChange
                                                                  }
                                                                />
                                                              </Form.Group>
                                                              {this.state.errorNet ? (
                                                                <span
                                                                  style={{
                                                                    color: "red",
                                                                    fontSize: "10px",
                                                                    marginBottom: "0",
                                                                  }}
                                                                >
                                                                  {this.state.errorNet}
                                                                </span>
                                                              ) : null}
                                                            </Col>
                                                            <Col>
                                                              <Form.Group className="mb-3">
                                                                <Form.Label style={{ fontSize: "9px" }}>
                                                                  Requested Patient Share*
                                                                </Form.Label>
                                                                <Form.Control
                                                                  type="text"
                                                                  name="requestedPatientShare"
                                                                  // required
                                                                  readOnly
                                                                  value={
                                                                    this.state.quantity &&
                                                                      this.state.patientShare
                                                                      ? this.state.quantity *
                                                                      this.state.patientShare
                                                                      : ""
                                                                  }
                                                                  onChange={
                                                                    this.HandleProcedureInputTextChange
                                                                  }
                                                                />
                                                              </Form.Group>
                                                              {this.state.errorRequestedpatientShare ? (
                                                                <span
                                                                  style={{
                                                                    color: "red",
                                                                    fontSize: "10px",
                                                                    marginBottom: "0",
                                                                  }}
                                                                >
                                                                  {this.state.errorRequestedpatientShare}
                                                                </span>
                                                              ) : null}
                                                            </Col>
                                                            <Col>
                                                              <Form.Group className="mb-3">
                                                                <Form.Label style={{ fontSize: "10px" }}>
                                                                  Payer Patient Share *
                                                                </Form.Label>
                                                                <Form.Control
                                                                  type="text"
                                                                  name="payerPatientShare"
                                                                  // required
                                                                  readOnly
                                                                  value={
                                                                    this.state.quantity &&
                                                                      this.state.patientShare
                                                                      ? this.state.quantity *
                                                                      this.state.unitPrice +
                                                                      this.state.quantity *
                                                                      this.state.tax -
                                                                      this.state.quantity *
                                                                      this.state.patientShare
                                                                      : ""
                                                                  }
                                                                  onChange={
                                                                    this.HandleProcedureInputTextChange
                                                                  }
                                                                />
                                                              </Form.Group>
                                                              {this.state.errorPayerpatientShare ? (
                                                                <span
                                                                  style={{
                                                                    color: "red",
                                                                    fontSize: "10px",
                                                                    marginBottom: "0",
                                                                  }}
                                                                >
                                                                  {this.state.errorPayerpatientShare}
                                                                </span>
                                                              ) : null}
                                                            </Col>
                                                          </Row>
                                                        </Col>
                                                      </div>
                                                    </Row>
                                                    <hr />
                                                    <Row>
                                                      <Col>
                                                        <Form.Group className="mb-3">
                                                          <Form.Label style={{ fontSize: "13px" }}>
                                                            Start Date\Time
                                                          </Form.Label>
                                                          <Form.Control
                                                            type="date"
                                                            name="servicedDate"
                                                            onChange={this.HandleProcedureInputTextChange}
                                                            // required
                                                            value={this.state.servicedDate}
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col>
                                                        <div>
                                                          <Form.Label style={{ fontSize: "13px" }}>
                                                            Related Supporting Info
                                                          </Form.Label>
                                                          <Multiselect
                                                            placeholder="Supporting Informatiom"
                                                            selectedValues={this.state.selectedOptions}
                                                            options={this.state.vitalSignSelectArray}
                                                            onSelect={this.onSelectCategory}
                                                            onRemove={this.onRemoveCategory}
                                                            displayValue="view"
                                                          // selectedValues={this.state.selectedOptions}
                                                          />
                                                        </div>
                                                      </Col>
                                                      <Col>
                                                        <div>
                                                          <Form.Label style={{ fontSize: "13px" }}>
                                                            Related Diagnosis
                                                          </Form.Label>
                                                          <Multiselect
                                                            placeholder="Diagnosis"
                                                            options={this.state.allDiagnosisSelect}
                                                            onSelect={this.onSelectDiagnosis}
                                                            onRemove={this.onRemoveDiagnosis}
                                                            displayValue="view"
                                                          // selectedValues={this.state.selectedOptions}
                                                          />
                                                        </div>
                                                      </Col>
                                                      <Col>
                                                        <div>
                                                          <Form.Label style={{ fontSize: "13px" }}>
                                                            Care Teams
                                                          </Form.Label>
                                                          <Multiselect
                                                            placeholder="CareTeams"
                                                            options={this.state.allCareTeamSelect}
                                                            onSelect={this.onSelectCareTeams}
                                                            onRemove={this.onRemoveCareTeams}
                                                            displayValue="view"
                                                          // selectedValues={this.state.selectedOptions}
                                                          />
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                    <Row>
                                                      <Col>
                                                        <Form.Group className="mb-3">
                                                          <Form.Label style={{ fontSize: "13px" }}>
                                                            None Standard Code
                                                          </Form.Label>
                                                          <Form.Control
                                                            type="text"
                                                            name="nonstandardCode"
                                                            // required
                                                            onChange={this.HandleProcedureInputTextChange}
                                                          />
                                                        </Form.Group>
                                                        <div>
                                                          <Button
                                                            variant="primary"
                                                            type="submit"
                                                            onClick={(e) => this.handleAddProcedure(e)}
                                                            style={{
                                                              width: "45%",
                                                              backgroundColor: "rgb(78 75 75)",
                                                              border: "1px solid rgb(78 75 75)",
                                                              marginRight: "5px",
                                                            }}
                                                          >
                                                            {" "}
                                                            Add
                                                          </Button>
                                                          <Button
                                                            variant="primary"
                                                            type="submit"
                                                            onClick={(e) => this.handleRestItemsValue(e)}
                                                            style={{
                                                              width: "45%",
                                                              backgroundColor: "rgb(78 75 75)",
                                                              border: "1px solid rgb(78 75 75)",
                                                            }}
                                                          >
                                                            Reset
                                                          </Button>
                                                        </div>
                                                        {this.state.proceduresError ? (
                                                          <span
                                                            style={{
                                                              color: "red",
                                                              fontSize: "12px",
                                                              marginBottom: "0",
                                                            }}
                                                          >
                                                            {this.state.proceduresError}
                                                          </span>
                                                        ) : null}
                                                      </Col>
                                                      <Col>
                                                        <Form.Group className="mb-3">
                                                          <Form.Label style={{ fontSize: "13px" }}>
                                                            None Standard Display
                                                          </Form.Label>
                                                          <Form.Control
                                                            type="text"
                                                            name="standardDisplay"
                                                            // required
                                                            onChange={this.HandleProcedureInputTextChange}
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col style={{ position: "relative" }}>
                                                        <div style={{
                                                          display: "flex", justifyContent: "space-between", position: "absolute",
                                                          top: "32px",
                                                          left: "8%",
                                                        }}>
                                                          <Button
                                                            disabled={this.state.productOrService.code ? false : true}
                                                            variant="primary"
                                                            type="submit"
                                                            onClick={(e) => this.getPriceListInfo(e)}
                                                            style={{
                                                              width: "54%",
                                                              backgroundColor: "rgb(78 75 75)",
                                                              border: "1px solid rgb(78 75 75)",
                                                              fontSize: "10px",
                                                              height: "37px",
                                                              transition: "background-color 0.4s, color 0.4s",

                                                            }}
                                                          >
                                                            {this.state.getPriceListLoading ? "Loading ... " : "Get Price List Info"}
                                                          </Button>
                                                          <div
                                                            style={{

                                                              padding: "10px",
                                                            }}
                                                          >

                                                            <input
                                                              type="checkbox"
                                                              name="isPackage"
                                                              onChange={(e) => this.handleCheckBoxChange(e)}
                                                            />
                                                            <span
                                                              style={{
                                                                fontSize: "13px",
                                                                margin: "3px",
                                                                display: "inline-block",
                                                              }}
                                                            >
                                                              package
                                                            </span>

                                                          </div>
                                                        </div>

                                                      </Col>
                                                      <Col>
                                                        <Form.Group className="mb-3">
                                                          <Form.Label style={{ fontSize: "13px" }}>
                                                            Body Site
                                                          </Form.Label>
                                                          <Form.Select
                                                            onChange={this.HandleProcedureInputTextChange}
                                                            // required
                                                            name="bodySite"
                                                          >
                                                            <option value="0">Please Select</option>
                                                            {/* <option value="NI">NI</option> */}
                                                          </Form.Select>
                                                        </Form.Group>
                                                      </Col>
                                                      <Col>
                                                        <Form.Group className="mb-3">
                                                          <Form.Label style={{ fontSize: "13px" }}>
                                                            Body Sub Site
                                                          </Form.Label>
                                                          <Form.Select
                                                            onChange={this.HandleProcedureInputTextChange}
                                                            // required
                                                            name="bodySubSite"
                                                          >
                                                            <option value="0">Please Select</option>
                                                            {/* <option value="NI">NI</option> */}
                                                          </Form.Select>
                                                        </Form.Group>
                                                      </Col>
                                                    </Row>
                                                  </Container>
                                                </FormControl>
                                              </Accordion.Body>
                                            </Accordion.Item>
                                          </Accordion>

                                        </TableCell>
                                      </TableRow>
                                    ) : null}
                                    {editClaim ? (
                                      <TableRow>
                                        <TableCell align="center" colSpan={9}>
                                          <Button
                                            style={{
                                              width: "10%",
                                              backgroundColor: "rgb(97 110 120",
                                              border: "1px ridge gray",
                                              color: "white",
                                              fontSize: "smaller",
                                            }}
                                            onClick={(e) => {
                                              this.setState({ addProcedure: true })
                                            }}
                                          >
                                            <AddCircleIcon />
                                          </Button>
                                        </TableCell>
                                      </TableRow>
                                    ) : null}
                                  </Table>
                                </TableContainer>
                              </>
                            ) : null}
                            <hr />
                            <>
                              {this.state.outcome != null ? (
                                <>
                                  <h4 style={{ textAlign: "center" }}>
                                    Authorization Response
                                  </h4>
                                  {this.state.requestbundleId ? (
                                    <>
                                      <h6 style={{ marginTop: "10px" }}>
                                        Request Bundle ID :{" "}
                                        {this.state.requestbundleId}
                                      </h6>
                                    </>
                                  ) : null}
                                  {this.state.responsebundleId ? (
                                    <>
                                      <h6 style={{ marginTop: "10px" }}>
                                        Response Bundle ID :{" "}
                                        {this.state.responsebundleId}
                                      </h6>
                                    </>
                                  ) : null}

                                  {this.state.outcome === "complete" ? (
                                    <>
                                      {items &&
                                        items.length > 0 &&
                                        itemRows.length > 0 ? (
                                        <>
                                          <h4 style={{ textAlign: "center" }}>
                                            Items
                                          </h4>
                                          <TableContainer
                                            component={Paper}
                                            style={{
                                              margin: "10px auto",
                                              width: "100%",
                                            }}
                                          >
                                            <Table aria-label="simple table">
                                              <TableHead
                                                style={{
                                                  backgroundColor: "#fafafa",
                                                }}
                                              >
                                                <TableRow
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <TableCell align="center">
                                                    Code
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Item Sequence
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Outcome
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Adjudications
                                                  </TableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>{itemRows}</TableBody>
                                            </Table>
                                          </TableContainer>
                                        </>
                                      ) : null}
                                      {totalRows && totalRows.length > 0 ? (
                                        <>
                                          <h4 style={{ textAlign: "center" }}>
                                            Total
                                          </h4>
                                          <TableContainer
                                            component={Paper}
                                            style={{
                                              margin: "10px auto",
                                              width: "100%",
                                            }}
                                          >
                                            <Table aria-label="simple table">
                                              <TableHead
                                                style={{
                                                  backgroundColor: "#fafafa",
                                                }}
                                              >
                                                <TableRow
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <TableCell align="center">
                                                    Category
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Amount
                                                  </TableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>{totalRows}</TableBody>
                                            </Table>
                                          </TableContainer>
                                        </>
                                      ) : null}
                                    </>
                                  ) : null}

                                  {this.state.outcome === "queued" ? (
                                    <TableContainer
                                      component={Paper}
                                      style={{
                                        margin: "10px auto",
                                        width: "100%",
                                      }}
                                    >
                                      <Table aria-label="simple table">
                                        <TableHead
                                          style={{ backgroundColor: "#fafafa" }}
                                        >
                                          <TableRow
                                            style={{ textAlign: "center" }}
                                          >
                                            <TableCell align="center">
                                              Outcome
                                            </TableCell>
                                            <TableCell align="center">
                                              Authorization Request Identifier
                                            </TableCell>
                                            <TableCell align="center">
                                              Authorization Response Identifier
                                            </TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          <TableCell align="center">
                                            {this.state.outcome}
                                          </TableCell>
                                          <TableCell align="center">
                                            {
                                              this.state
                                                .authorizationRequestIdentifier
                                            }
                                          </TableCell>
                                          <TableCell align="center">
                                            {
                                              this.state
                                                .authorizationResponseIdentifier
                                            }
                                          </TableCell>
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  ) : null}
                                  {this.state.outcome === "error" ? (
                                    <>
                                      <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        component="h2"
                                        style={{ textAlign: "center" }}
                                      >
                                        Errors
                                      </Typography>
                                      <TableContainer
                                        component={Paper}
                                        style={{
                                          margin: "10px auto",
                                          width: "100%",
                                        }}
                                      >
                                        <Table aria-label="simple table">
                                          <TableHead
                                            style={{
                                              backgroundColor: "#fafafa",
                                            }}
                                          >
                                            <TableRow
                                              style={{ textAlign: "center" }}
                                            >
                                              <TableCell align="center">
                                                Code
                                              </TableCell>
                                              <TableCell align="center">
                                                Display
                                              </TableCell>
                                              <TableCell align="center">
                                                Extension
                                              </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>{errorRows}</TableBody>
                                        </Table>
                                      </TableContainer>
                                    </>
                                  ) : null}
                                </>
                              ) : null}
                            </>
                          </Row>
                        </div>
                      </Box>
                    </Modal>
                  ) : null}
                  {this.state.showResubmissionError ? (
                    <>
                      <Modal
                        open={this.state.showResubmissionError}
                        onClose={this.handleCloseResubmissionErrorModal}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      // style={{ overflowY: "scroll" }}
                      >
                        <Box
                          sx={style}
                          style={{
                            width: "50%",
                            height: "380",
                          }}
                        >
                          <Row>
                            <Typography
                              id="modal-modal-title"
                              variant="h6"
                              component="h2"
                              style={{ textAlign: "center" }}
                            >
                              Errors
                            </Typography>
                            <TableContainer
                              component={Paper}
                              style={{
                                margin: "10px auto",
                                width: "100%",
                              }}
                            >
                              <Table aria-label="simple table">
                                <TableHead
                                  style={{
                                    backgroundColor: "#fafafa",
                                  }}
                                >
                                  <TableRow
                                    style={{ textAlign: "center" }}
                                  >
                                    <TableCell align="center">
                                      Code
                                    </TableCell>
                                    <TableCell align="center">
                                      Display
                                    </TableCell>
                                    <TableCell align="center">
                                      Extension
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>{resubmissionErrorRows}</TableBody>
                              </Table>
                            </TableContainer>
                          </Row>
                        </Box>
                      </Modal>
                    </>
                  ) : null}
                  {this.state.cancelError ? (
                    <>
                      <Stack
                        style={{
                          position: "fixed",
                          top: 10,
                          right: 10,
                          zIndex: 9999,
                          textTransform: "capitalize",
                        }}
                      >
                        <Alert severity="info">{this.state.cancelError}</Alert>
                      </Stack>
                    </>
                  ) : null}
                  {this.state.cancelModalOpen ? (
                    <>
                      <Modal
                        open={this.state.cancelModalOpen}
                        onClose={this.handleCloseCancelErrorModal}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      // style={{ overflowY: "scroll" }}
                      >
                        <Box
                          sx={style}
                          style={{
                            width: "50%",
                            height: "380",
                          }}
                        >
                          <Row>
                            <Typography
                              id="modal-modal-title"
                              variant="h6"
                              component="h2"
                              style={{ textAlign: "center" }}
                            >
                              Cancel Errors
                            </Typography>
                            {this.state.cancelErrors &&
                              this.state.cancelErrors.length > 0 ? (
                              <>
                                <div
                                  style={{
                                    width: "100%",
                                    margin: "auto",
                                    height: "200px",
                                  }}
                                >
                                  <TableContainer
                                    component={Paper}
                                    style={{
                                      margin: "auto",
                                      width: "100%",
                                      overflowY: "auto",
                                    }}
                                  >
                                    <Table aria-label="simple table">
                                      <TableHead
                                        style={{ backgroundColor: "#fafafa" }}
                                      >
                                        <TableRow
                                          style={{ textAlign: "center" }}
                                        >
                                          <TableCell align="center">
                                            Error Code
                                          </TableCell>
                                          <TableCell align="center">
                                            Error Display
                                          </TableCell>
                                          <TableCell align="center">
                                            Error Extension
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {this.state.cancelErrors.map(
                                          (element, index) => {
                                            return (
                                              <TableRow key={index}>
                                                <TableCell
                                                  align="center"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  {element.code}
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  {element.display}
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  {element.extension}
                                                </TableCell>
                                              </TableRow>
                                            );
                                          }
                                        )}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </div>
                              </>
                            ) : null}
                          </Row>
                        </Box>
                      </Modal>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </>
      </>
    );
  }
}
export default AuthorizationHistory;
